import type {Component} from 'grapesjs';
import {colorToHexString} from '@Utils/color.util';

export function getUniformDescriptionTextColor(description: Component): string | null {
  const descEl = description.getEl();
  if (!descEl) {
    return null;
  }

  const colors = collectTextColors(descEl);
  if (colors.size !== 1) {
    return null;
  }

  return [...colors][0] ?? null;
}

export function applyEntireDescriptionTextColor(description: Component, color: string): void {
  const descEl = description.getEl();

  if (descEl) {
    stripInnerColorOverrides(descEl);
    description.components(descEl.innerHTML, {silent: true});
  }

  description.addStyle({color});
}

function collectTextColors(descEl: HTMLElement): Set<string> {
  const doc = descEl.ownerDocument;
  const walker = doc.createTreeWalker(descEl, NodeFilter.SHOW_TEXT);
  const colors = new Set<string>();

  let node = walker.nextNode();
  while (node) {
    const parent = node.parentElement;
    if (parent && (node.textContent ?? '').trim() !== '') {
      colors.add(colorToHexString(doc.defaultView?.getComputedStyle(parent).color ?? ''));
    }

    node = walker.nextNode();
  }

  return colors;
}

function stripInnerColorOverrides(descEl: HTMLElement): void {
  descEl.querySelectorAll<HTMLElement>('[color]').forEach((el): void => {
    el.removeAttribute('color');
  });

  descEl.querySelectorAll<HTMLElement>('[style]').forEach((el): void => {
    el.style.removeProperty('color');
  });
}
